var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center ebp-spinner"},[_c('i',{class:`bx bx-loader bx-spin font-size-16 align-middle mr-2 text-${_vm.color}`})])
}
var staticRenderFns = []

export { render, staticRenderFns }